export function createCorp(id, corp) {
    let { createCorpRequest, createCorpError, createCorpResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/corp/save',
        this.createBundle('app/corp/save', { id, corp }, this.POST, createCorpRequest, createCorpResult, createCorpError)
    )
}
